module.exports = __webpack_public_path__ + "static/media/sean_rules_2.3783ad71.png";